import { useCallback, useEffect, useState } from 'react';
import {
  servicosApi,
  type AtualizarServicoRequest,
  type ServicoResumo,
} from '@/features/servicos/api/servicosApi';
import { useSyncReload } from '@/shared/hooks/useSyncReload';

type Estado = {
  servicos: ServicoResumo[];
  carregando: boolean;
  erro: string | null;
};

export function useServicos() {
  const [estado, setEstado] = useState<Estado>({
    servicos: [],
    carregando: false,
    erro: null,
  });

  const recarregar = useCallback(() => {
    setEstado((s) => ({ ...s, carregando: true, erro: null }));
    return servicosApi.listar().then(
      (servicos) => setEstado({ servicos, carregando: false, erro: null }),
      (e: unknown) => {
        const mensagem = e instanceof Error ? e.message : 'Erro desconhecido';
        setEstado((s) => ({ ...s, carregando: false, erro: mensagem }));
      },
    );
  }, []);

  const atualizar = useCallback(
    async (id: string, dados: AtualizarServicoRequest) => {
      await servicosApi.atualizar(id, dados);
      void recarregar();
    },
    [recarregar],
  );

  const excluir = useCallback(
    async (id: string) => {
      setEstado((s) => ({
        ...s,
        servicos: s.servicos.filter((sv) => sv.id !== id),
      }));
      try {
        await servicosApi.excluir(id);
      } finally {
        void recarregar();
      }
    },
    [recarregar],
  );

  useEffect(() => {
    void recarregar();
  }, [recarregar]);

  useSyncReload(recarregar);

  return { ...estado, recarregar, atualizar, excluir };
}
